<mat-form-field style="padding-right:20px;">
  <mat-label>DATE</mat-label>
  <mat-select (selectionChange)="selectDateOption($event)">
    <mat-option *ngFor="let dateOption of dateOptions" [value]="dateOption.value">
      {{ dateOption.viewValue }}
    </mat-option>
  </mat-select>
</mat-form-field>

<mat-form-field *ngIf="selectedDateOption=='customDateRange'" style="padding-right:20px;">
  <mat-label>DATE RANGE</mat-label>
  <mat-date-range-input [rangePicker]="picker">
    <input matStartDate placeholder="Start date" (dateChange)="selectCustomDateRangeStart($event)">
    <input matEndDate placeholder="End date" (dateChange)="selectCustomDateRangeEnd($event)">
  </mat-date-range-input>
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-date-range-picker #picker></mat-date-range-picker>
</mat-form-field>

<button mat-icon-button type="button" (click)="getDutyReport()"><mat-icon>refresh</mat-icon></button>

<div *ngIf="loading">
  <h3 style="text-align:center;">LOADING REPORT</h3>
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>

<div *ngIf="!loading && report" class="duty-summary">
  <div>
    <span>DUTY PAID</span>
    <strong>{{ report.paidInRange | currency }}</strong>
  </div>
  <div>
    <span>DUTY RECOVERED</span>
    <strong>{{ report.recoveredInRange | currency }}</strong>
  </div>
  <div>
    <span>RECOVERED − PAID</span>
    <strong>{{ report.differenceInRange | currency }}</strong>
  </div>
  <div>
    <span>PAID YTD</span>
    <strong>{{ report.paidYtd | currency }}</strong>
  </div>
  <div>
    <span>RECOVERED YTD</span>
    <strong>{{ report.recoveredYtd | currency }}</strong>
  </div>
  <div>
    <span>YTD RECOVERED − PAID</span>
    <strong>{{ report.differenceYtd | currency }}</strong>
  </div>
</div>

<mat-table *ngIf="!loading && report" [dataSource]="report.byVendor" class="mat-elevation-z2">
  <ng-container matColumnDef="vendor">
    <mat-header-cell *matHeaderCellDef fxFlex="1 1 200px">VENDOR</mat-header-cell>
    <mat-cell *matCellDef="let row" fxFlex="1 1 200px">{{ row.name }}</mat-cell>
  </ng-container>
  <ng-container matColumnDef="paid">
    <mat-header-cell *matHeaderCellDef fxFlex="1 1 140px">DUTY PAID</mat-header-cell>
    <mat-cell *matCellDef="let row" fxFlex="1 1 140px">{{ row.paid | currency }}</mat-cell>
  </ng-container>
  <ng-container matColumnDef="recovered">
    <mat-header-cell *matHeaderCellDef fxFlex="1 1 160px">DUTY RECOVERED</mat-header-cell>
    <mat-cell *matCellDef="let row" fxFlex="1 1 160px">{{ row.recovered | currency }}</mat-cell>
  </ng-container>
  <ng-container matColumnDef="difference">
    <mat-header-cell *matHeaderCellDef fxFlex="1 1 160px">RECOVERED − PAID</mat-header-cell>
    <mat-cell *matCellDef="let row" fxFlex="1 1 160px">{{ row.difference | currency }}</mat-cell>
  </ng-container>
  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
  <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
</mat-table>
